

import React from "react";
import {
  FaCheckCircle,
  FaRocket,
  FaCrown,
  FaStar,
} from "react-icons/fa";

const Premium = () => {
  const plans = [
    {
      title: "1 Year Plan",
      price: "₹ 8,000",
      duration: "/ Year",
      icon: <FaRocket size={50} />,
      buttonText: "Active Plan",
     
      buttonClass: "btn-success",
  bg: "linear-gradient(135deg,#A5D74A,#A5D74A)",
      features: [
        "Multiple Counter Billing",
        "Barcode Generation",
        "Multi Business Management",
        "Inventory Reports",
      ],
    },
    {
      title: "3 Years Plan",
      price: "₹ 12,000",
      duration: "/ Year",
      icon: <FaCrown size={50} />,
      buttonText: "Subscribe Now",
      buttonClass: "btn-primary",
      popular: true,
      bg: "linear-gradient(135deg,#667eea,#764ba2)",
      features: [
        "Multiple Counter Billing",
        "Barcode Generation",
        "Multi Business Management",
        "Inventory Reports",
        "Priority Support",
      ],
    },
  ];

  return (
    <div
      className="container-fluid py-5"
      style={{
        background:
          "linear-gradient(to right,#eef2ff,#f8fafc)",
        minHeight: "100vh",
      }}
    >
      <div className="container">
     
        <div className="text-center mb-5">
          <h1 className="fw-bold display-5">
            <FaCrown className="text-warning me-2" />
            Premium Plans
          </h1>

          <p className="text-muted fs-5">
            Choose the perfect plan for your business growth
          </p>
        </div>

    
        <div className="row justify-content-center g-4">
          {plans.map((plan, index) => (
            <div className="col-lg-5 col-md-6" key={index}>
              <div
                className="card border-0 shadow-lg h-100 position-relative"
                style={{
                  borderRadius: "30px",
                  overflow: "hidden",
                  transition: "0.4s",
                }}
              >
               
                {plan.popular && (
                  <div
                    className="position-absolute"
                    style={{
                      top: 20,
                      right: 20,
                      zIndex: 10,
                    }}
                  >
                    <span className="badge bg-warning text-dark px-3 py-2">
                      <FaStar className="me-1" />
                      MOST POPULAR
                    </span>
                  </div>
                )}

              
                <div
                  className="text-center text-white p-5"
                  style={{
                    background: plan.bg,
                  }}
                >
                  <div className="mb-3">{plan.icon}</div>

                  <h2 className="fw-bold">{plan.title}</h2>

                  <h1 className="fw-bold mt-3">
                    {plan.price}
                    <span className="fs-5 fw-normal">
                      {plan.duration}
                    </span>
                  </h1>
                </div>

              
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-4">
                    Included Features
                  </h5>

                  {plan.features.map((feature, i) => (
                    <div
                      key={i}
                      className="d-flex align-items-center mb-3"
                    >
                      <FaCheckCircle
                        className="text-success me-3"
                        size={18}
                      />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="p-4 pt-0">
               <div className="p-4 pt-0">
  {plan.title === "1 Year Plan" ? (
    <div className="d-flex gap-2">
      <button
        className="btn btn-success flex-fill fw-bold rounded-pill py-3"
      >
        ✓ Active Plan
      </button>

      <button
        className="btn btn-primary flex-fill fw-bold rounded-pill py-3"
      >
        Renew
      </button>
    </div>
  ) : (
    <button
      className={`btn ${plan.buttonClass} w-100 fw-bold rounded-pill py-3`}
    >
      {plan.buttonText}
    </button>
  )}
</div>
                </div>
              </div>
            </div>
          ))}
        </div>

  
        <div className="text-center mt-5">
          <div className="card border-0 shadow-sm rounded-4 p-4">
            <h4 className="fw-bold mb-2">
              Need Help Choosing?
            </h4>

            <p className="text-muted mb-0">
              Contact our support team to find the best plan
              for your business.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Premium;